import { Button, Grid, Typography } from '@mui/material'
import Image from 'next/image'
import { Trans, useTranslation } from 'react-i18next'
import type { ResourceTypeStringKey } from '../OrganisationMismatch'

type Props = {
  currentOrganisationName: string
  correctOrganisationName: string
  resourceType: ResourceTypeStringKey
  onSwitch: () => void
}

export const OrganisationSwitchScreen = ({ currentOrganisationName, correctOrganisationName, resourceType, onSwitch }: Props) => {
  const { t } = useTranslation('common')

  const resourceTypeString = t(`organisation-switch-boundary.resourceTypes.${resourceType}`)

  return (
    <Grid container spacing={0} direction="column" alignItems="center" justifyContent="center" style={{ minHeight: '100vh' }}>
      <Grid
        container
        direction="column"
        sx={(theme) => ({
          backgroundColor: theme.palette.bg.surface.elevated,
          borderRadius: '8px',
          boxShadow: theme.customShadows.sm,
          alignItems: 'center',
          textAlign: 'center',
          padding: '40px',
          width: '480px',
        })}
      >
        <Image
          src="/app/assets/organisation-switch.png"
          alt="error"
          width={1536}
          height={1024}
          style={{ width: 250, height: 'auto' }}
        />
        <Grid>
          <Typography sx={{ mt: '30px', color: 'text.default', fontSize: '25px', fontWeight: 600 }}>
            <Trans
              i18nKey="common:organisation-switch-boundary.title"
              components={{
                bold: <b />,
              }}
              values={{
                type: resourceTypeString,
                correctOrganisationName,
              }}
            />
          </Typography>
        </Grid>
        <Grid>
          <Typography sx={{ mt: '15px', color: 'text.muted', fontSize: '14px', fontWeight: 400 }}>
            <Trans
              i18nKey="common:organisation-switch-boundary.subtext1"
              components={{
                bold: <b />,
              }}
              values={{
                type: resourceTypeString,
                currentOrganisationName,
              }}
            />
          </Typography>
        </Grid>
        <Grid>
          <Typography sx={{ mt: '15px', color: 'text.muted', fontSize: '14px', fontWeight: 400 }}>
            {t('organisation-switch-boundary.subtext2')}
          </Typography>
        </Grid>
        <Button
          sx={{
            mt: '20px',
            '&:focus': {
              animation: 'pulse 1.25s infinite',
            },
            '@keyframes pulse': pulseKeyframes,
          }}
          variant="contained"
          onClick={onSwitch}
          autoFocus
        >
          {t('organisation-switch-boundary.button', { correctOrganisationName })}
        </Button>
      </Grid>
    </Grid>
  )
}

const pulseKeyframes = {
  '0%': {
    boxShadow: '0 0 0 0 rgba(16, 185, 129, 1)',
  },
  '80%': {
    boxShadow: '0 0 0 8px rgba(16, 185, 129, 0)',
  },
  '100%': {
    boxShadow: '0 0 0 0 rgba(16, 185, 129, 0)',
  },
}
